var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-backtop',{attrs:{"bottom":100,"visibility-height":650}},[_c('div',{staticClass:"back_top"},[_vm._v(" UP ")])]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }